// extracted by mini-css-extract-plugin
export default {"formContent":"AddEditContactDialogContent_formContent__l6h4+","fullWidth":"AddEditContactDialogContent_fullWidth__wMwjm","chip":"AddEditContactDialogContent_chip__VlvIq"};